import { render } from "./Header.vue?vue&type=template&id=913351b0&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=913351b0&lang=scss&scoped=true"
import "./Header.vue?vue&type=style&index=1&id=913351b0&lang=scss&global=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-913351b0"],['__file',"src/scripts/view/publicPages/components/Header.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "913351b0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('913351b0', __exports__)) {
    api.reload('913351b0', __exports__)
  }
  
  module.hot.accept("./Header.vue?vue&type=template&id=913351b0&scoped=true", () => {
    api.rerender('913351b0', render)
  })

}


export default __exports__